import store from '../store/index'
import { isIdleLockEnabled } from './idleLock'

function toDo() {
  if (!isIdleLockEnabled()) {
    return true
  }
  const str = sessionStorage.getItem('lock')
  const myStorage = JSON.parse(str)
  if (myStorage === true) {
    store.commit('changeLock', true)
    return false
  }
  if (myStorage === false) {
    return true
  }
  return true
}

export default {
  toDo
}
